import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetSubCategoryImage, GetMediaById, api_url, GetSubCategoryById } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";

function ViewMedia() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [subCategoryData, setSubCategoryData] = useState(null);
    const [mediaData, setMediaData] = useState([]);
    const { mediaid } = useParams();
    const [loading, setLoading] = useState(false);

    const formatUTCDate = (utcDateString) => {
      const date = new Date(utcDateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    useEffect(() => {
        (
            async () => {
                setLoading(true);
                try {
                    const response = await GetMediaById(mediaid, localStorage.getItem('accessToken'));
                    if (response?.data) {
                        await getSubCategoryData(
                          response?.data?._doc?.subcategoryid
                        );
                    }
                    setLoading(false);
                    setMediaData(response?.data);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false);
                }
            }
        )();
    }, []);

    const getSubCategoryData = async (subcategoryid) => { 
        setLoading(true);
      try {
        const response = await GetSubCategoryById(
          subcategoryid,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setSubCategoryData(response?.data?._doc);
      } catch (error) {
        console.log(error);
      } finally {
          setLoading(false);
      }
    };

    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Media Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/media" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                        <NavLink to={`/editMedia/${mediaid}`} className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink>
                    </div>
                </div>
                {
                    loading ?
                        <div className="d-flex align-items-center justify-content-center">
                            <RiLoaderFill size={40} className="text-success spin-animation text-center" />
                        </div>
                        :
                        <div className="detailsBox">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover w-100">
                                            <tbody>
                                                <tr>
                                                    <th>Title</th>
                                                    <td>{mediaData?._doc?.title}</td>
                                                </tr>
                                                <tr>
                                                    <th>Image</th>
                                                    <td><img width="100px" height="100px" src={`${api_url}/product/category/getSubcategoryImage/${mediaData?._doc?.image}`} /></td>
                                                </tr>
                                                <tr>
                                                    <th>Status</th>
                                                    <td>{mediaData?.statusInfo?.status}</td>
                                                </tr>
                                                <tr>
                                                    <th>Screen Type</th>
                                                    <td>{subCategoryData?.name}</td>
                                                </tr>
                                                {
                                                    mediaData?._doc?.urlLink && (
                                                        <tr>
                                                            <th>URL Link</th>
                                                            <td>{mediaData?._doc?.urlLink}</td>
                                                        </tr>
                                                    )
                                                }
                                                <tr>
                                                    <th>Created Date</th>
                                                    <td>{formatUTCDate(mediaData?._doc?.createddate)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Modified Date</th>
                                                    <td>{formatUTCDate(mediaData?._doc?.modifieddate)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Created By</th>
                                                    <td>{mediaData?._doc?.createdby}</td>
                                                </tr>
                                                <tr>
                                                    <th>Modified By</th>
                                                    <td>{mediaData?._doc?.modifiedby}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                }
            </div>
        </div>
    );
}
export default ViewMedia;